export const YES_NO_VALUES = {
    No: 'No',
    Yes: 'Yes',
};
